module.exports = __webpack_public_path__ + "static/media/edyoda.74df69dc.jpg";